import React, {JSX} from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
    component: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    className?: string;
}

export default function Icon(props: IconProps): JSX.Element | null {
    const {component: Component, className, ...rest} = props;

    const kebabCaseIconName = Component.name
        .replace(/[A-Z]/g, m => "-" + m.toLowerCase())
        .replace(`-svg-`, ``);

    return <span className={`icon ${kebabCaseIconName} ${className || ""}`}><Component {...rest} /></span>;
}
